import { SalesforceConnectionDetails } from '../../interfaces/salesforce/salesforce-connection-details';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { Transformation } from '../data-mapper/transformation';

/**
 * Configuration for a SalesforceSaveObjects task — bulk-upserts records into a Salesforce
 * object using the jsforce client_credentials OAuth flow. Each input record maps to one
 * Salesforce object row. If fieldMappings is empty, record.processingData is sent as-is.
 */
export class SalesforceSaveObjectsConfig
	extends DestinationTaskConfigBase
	implements SalesforceConnectionDetails
{
	/**
	 * Salesforce connected-app OAuth client ID.
	 * @default ''
	 */
	clientId = '';

	/**
	 * Salesforce connected-app OAuth client secret. Resolved via GETSECRET() expression at runtime.
	 * @default ''
	 */
	clientSecret = '';

	/**
	 * Salesforce instance URL (e.g. 'https://myorg.salesforce.com').
	 * Used as both `instanceUrl` and `loginUrl` in the OAuth connection.
	 * @default ''
	 */
	instanceURL = '';

	/**
	 * Salesforce API name of the object to upsert (e.g. 'Contact', 'Lead', 'Account').
	 * @default ''
	 */
	salesforceObjectType = '';

	/**
	 * Salesforce field name used as the external/unique key for upsert deduplication.
	 * Set to a custom external ID field (e.g. 'External_ID__c') to upsert by that field.
	 * @default 'Id'
	 */
	externalId = 'Id';

	/**
	 * Field mapping transformations. Each entry maps a source processingData path
	 * (sourceMappings[0].mappingFields[0].objectKey) to a Salesforce field name
	 * (destinationMapping.mappingFields[0].objectKey).
	 * If empty, record.processingData is sent to Salesforce directly.
	 * @default []
	 */
	fieldMappings: Transformation[] = [];

	constructor(init?: Partial<SalesforceSaveObjectsConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
